import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './LocationListItem.module.scss';

// Marker Details
import MarkerDetails from '../MarkerDetails/MarkerDetails';

const LocationListItem = ({
    locationObject,
}) => {
    if (locationObject.categoryId === 'companyLocation') {
        return <MarkerDetails styles={styles} markerObject={locationObject} />;
    }
};

LocationListItem.propTypes = {
    locationObject: PropTypes.shape({
        categoryId: PropTypes.string,
        name: PropTypes.string,
        streetName: PropTypes.string,
        houseNumber: PropTypes.string,
        postCode: PropTypes.string,
        community: PropTypes.string,
        country: PropTypes.string,
        homepage: PropTypes.string,
    }),
};

export default LocationListItem;
